var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"q-pa-md"},[_c('h1',[_vm._v("Dashboard")]),_c('p',[_vm._v("Welcome back!")]),_c('q-btn',{attrs:{"to":("/" + (_vm.$route.params.locale) + "/dashboard/group"),"color":"primary","label":"Groups"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }